module.exports = __webpack_public_path__ + "assets/c4b7c5faf5d70d1a4cb6fdc706fddf45.mp4";